// extracted by mini-css-extract-plugin
export default {"table":"StatusChaneRules_table__FK3-p","cell":"StatusChaneRules_cell__7RLEM"};